import * as React from "react";
import * as main from "../../styles/main.module.scss";
import * as about from "../../styles/about.module.scss";

export const HowTo = () => {
  return (
    <section className={`${about.about} ${about.howTo}`}>
      <div className={main.containerFluid}>
        <h2 className={main.titleH2}>Курс устроен так, чтобы ребенку не было скучно</h2>
        <div className={about.about__imgBlock}>
          <div className={`${about.about__imgItemWrap} ${about.about__imgItemWrapLeft}`}>
            <div className={about.about__imgItem}>
              <div className={about.about__imgItemTitle}>Индивидуальный подход</div>
              <p>
                Программа составляется с учетом индивиуальных интересов и предпочтений ребенка. На старте мы активно
                задействуем процессную мотивацию. Игровые упражнения позволяют плавно и мягко вовлечь ребенка в
                обучение, даже при низкой мотивации.
              </p>
            </div>
            <div className={about.about__imgItem}>
              <div className={about.about__imgItemTitle}>Не помешает учебе в школе</div>
              <p>
                Курс рассчитан на 150-200 академических часов и проходится примерно за год. <br/>
                Занятия проходят дистанционно в удобное время, но при отдельном согласовании и оплате возможно и очное
                обучение, в том числе в другой стране.
              </p>
            </div>
          </div>
          <div className={`${about.about__imgItemWrap} ${about.about__imgItemWrapRight}`}>
            <div className={about.about__imgItem}>
              <div className={about.about__imgItemTitle}>Приучаем быть успешным</div>
              <p>
                Курс построен как череда заданий, выполнение каждого из которых дает два новых ощущения: я смог и у меня
                получилось то, что не получалось раньше. Наши педагоги помогают ученикам осознавать свои успехи и через
                это осознание выработать позицию, что любая амбициозная цель достижима, если приложить нужное количество
                усилий к своему развитию.
              </p>
            </div>
            <div className={about.about__imgItem}>
              <div className={about.about__imgItemTitle}>Подойдет каждому</div>
              <p>
                Наши индивидуальные занятия подходят более чем 99% детей.
                Из почти 20 000 детей, проходивших у нас обучение менее 1% оказались невосприимчивы к нашей методике
              </p>
            </div>
          </div>
          <img
            className={about.about__imgCircle}
            src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/photo-2-1.png"
            alt={""}
          />
        </div>
      </div>
    </section>
  );
};
